import { ReactElement, SVGProps } from 'react';
import BaseIcon from './BaseIcon';

export default function MoveIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path 
        d="M9.25 17.01q-.516 0-.883-.368A1.2 1.2 0 0 1 8 15.76q0-.515.367-.882.368-.368.883-.368.516 0 .883.368.367.367.367.882 0 .517-.367.883a1.2 1.2 0 0 1-.883.367m0-3.75q-.516 0-.883-.368A1.2 1.2 0 0 1 8 12.01q0-.515.367-.882.368-.368.883-.368.516 0 .883.368.367.367.367.882 0 .517-.367.883a1.2 1.2 0 0 1-.883.367m0-3.75q-.516 0-.883-.368A1.2 1.2 0 0 1 8 8.26q0-.515.367-.882.368-.368.883-.368.516 0 .883.368.367.367.367.882 0 .516-.367.883a1.2 1.2 0 0 1-.883.367m5 7.5q-.516 0-.883-.368A1.2 1.2 0 0 1 13 15.76q0-.515.367-.882.368-.368.883-.368.516 0 .883.368.367.367.367.882 0 .517-.367.883a1.2 1.2 0 0 1-.883.367m0-3.75q-.516 0-.883-.368A1.2 1.2 0 0 1 13 12.01q0-.515.367-.882.368-.368.883-.368.516 0 .883.368.367.367.367.882 0 .517-.367.883a1.2 1.2 0 0 1-.883.367m0-3.75q-.516 0-.883-.368A1.2 1.2 0 0 1 13 8.26q0-.515.367-.882.368-.368.883-.368.516 0 .883.368.367.367.367.882 0 .516-.367.883a1.2 1.2 0 0 1-.883.367"
       fill="currentColor"
       />
    </BaseIcon>
  )
}
